module.exports = __webpack_public_path__ + "/build/web/images/hero-testimonials.126f503e6edf7aae60a50b29a0cc886f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-testimonials.jpg
// module id = 148
// module chunks = 13